import { ShieldCheck, Clock, Anchor, PackageCheck, BadgeDollarSign, Globe2, FileCheck } from "lucide-react";

const items = [
  { icon: ShieldCheck, label: "Fully Insured Shipments" },
  { icon: Clock, label: "24/7 Customer Support" },
  { icon: Anchor, label: "5+ US Departure Ports" },
  { icon: PackageCheck, label: "Door-to-Port Service" },
  { icon: BadgeDollarSign, label: "Transparent Pricing" },
  { icon: Globe2, label: "USA → Ghana Specialists" },
  { icon: FileCheck, label: "Customs Cleared at Tema" },
];

export const TrustBar = () => (
  <section className="border-y border-gray-100 bg-white py-6" data-testid="trust-bar">
    <div className="relative overflow-hidden [mask-image:linear-gradient(to_right,transparent,black_8%,black_92%,transparent)]">
      <div className="flex w-max animate-marquee gap-12 pr-12">
        {[...items, ...items].map((it, i) => (
          <span key={i} className="flex shrink-0 items-center gap-2.5 text-sm font-semibold text-navy">
            <it.icon size={18} className="text-gold" />
            {it.label}
            <span className="ml-8 h-1.5 w-1.5 rounded-full bg-brandred/40" />
          </span>
        ))}
      </div>
    </div>
  </section>
);
